<template>
  <b-modal
    id="webhook-delete-modal"
    ref="webhookDeleteModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to delete this webhook?</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'WebhookDeleteModal',
  props: {
    webhookp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      webhookDeleted: 'webhook/webhookDeleted',
      apiError: 'webhook/apiError',
    }),
  },
  watch: {
    webhookDeleted(deleted) {
      if (deleted) {
        this.$emit('deleted', deleted);
        this.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteWebhook: 'webhook/deleteWebhook',
    }),
    commitDelete() {
      this.deleting = true;
      this.deleteWebhook({
        merchant_id: this.$route.params.merchant_id,
        webhook_id: this.webhookp.id,
      });
    },
    show() {
      this.$refs.webhookDeleteModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.webhookDeleteModal.hide();
    },
  },
};
</script>
